<template>
  <Primitive
    :class="styles({ class: props.class })"
    v-bind="forwarded"
  >
    <slot>{{ subtitle }}</slot>
  </Primitive>
</template>

<script lang="ts" setup>
import { Primitive } from 'reka-ui'
import type { PrimitiveProps } from 'reka-ui'

const props = withDefaults(
  defineProps<
    PrimitiveProps & {
      /** Custom class(es) to add to the parent */
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      class?: any
      /** The subtitle of the component */
      subtitle?: string
    }
  >(),
  {
    as: 'p',
  },
)
const forwarded = reactiveOmit(props, 'class', 'subtitle')
const styles = tv({
  base: 'text-xs md:text-sm text-muted-foreground flex flex-row gap-1',
})
</script>
